import { useEffect, useState } from 'react'

/**
 * Returns a value that updates on an interval, causing any component using it
 * to re-render periodically. Useful for time-based computations (like "is this
 * device overdue?") that need to re-evaluate even when no other state changes.
 *
 * @param intervalMs How often to tick. Default: 30 seconds.
 */
export function useNowTick(intervalMs: number = 30_000) {
    const [tick, setTick] = useState(0)

    useEffect(() => {
        const id = setInterval(() => setTick(t => t + 1), intervalMs)
        return () => clearInterval(id)
    }, [intervalMs])

    return tick
}
